import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children, requireAdmin = false }: ProtectedRouteProps) => {
  const { user, loading, role, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If admin route requested but user isn't admin
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/403" replace />;
  }

  // If client tries to access generic /dashboard, redirect to their portal
  if (!requireAdmin && !isAdmin && role === "client" && !location.pathname.startsWith("/portal/")) {
    return <Navigate to={`/portal/${user.id}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
